import { createFormData } from "@/mixins/Helpers";
import * as types from "./mutation-types";

export const fetchShops = ({ commit }, params = {}) => {
    return new Promise((resolve, reject) => {
        commit(types.SET_LOADING, true)
        window.axios.get('admin/get/shops', { params }).then((response) => {
            commit(types.SET_SHOPS, response.data.data || response.data.shops || [])
            if (response.data.meta) {
                commit(types.SET_PAGINATION, response.data.meta)
            }
            resolve(response)
        }).catch((err) => {
            reject(err)
        }).finally(() => {
            commit(types.SET_LOADING, false)
        })
    })
}

export const fetchShop = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        commit(types.SET_LOADING, true)
        window.axios.get(`admin/get/detail/${id}/shop`).then((response) => {
            commit(types.SET_SHOP, response.data.data || response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        }).finally(() => {
            commit(types.SET_LOADING, false)
        })
    })
}

export const createShop = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        const formData = createFormData(data)

        window.axios.post('admin/store/shop', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((response) => {
            commit(types.ADD_SHOP, response.data.shop)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateShop = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        const formData = createFormData(data)

        window.axios.post(`admin/update/${data.id}/shop`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((response) => {
            commit(types.UPDATE_SHOP, response.data.shop)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteShop = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`admin/delete/${id}/shop`).then((response) => {
            commit(types.DELETE_SHOP, id)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const addProductsToShop = (_, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('admin/add/product/in/'+data.shop_id+'/shop', data)
            .then((response) => {
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export const updateShopProduct = (_, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('admin/update/product/in/'+data.shop_id+'/shop', data)
            .then((response) => {
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export const removeProductFromShop = (_, { shopId, productId }) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`admin/remove/product/from/${shopId}/shop`, {data: {product_sale_element_id: productId}})
            .then((response) => {
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export const addProductsByCategory = (_, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`admin/add/product/in/${data.shop_id}/shop/by/category`, data)
            .then((response) => {
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export const addShopProductStock = (_, { shopId, productId, stock }) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`admin/add/product/stock/in/${shopId}/shop`, {product_sale_element_id: productId, stock_variable: stock})
            .then((response) => {
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}


export const toggleShopProductState = (_, { shopId, productId, online }) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`admin/toggle/product/state/in/${shopId}/shop`,{product_sale_element_id: productId, online})
            .then((response) => {
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

// Shop Users
export const fetchShopUsers = (_, shopId) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`admin/get/shop-users/collection`, { params: { shop_id: shopId } })
            .then((response) => {
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export const addUsersToShop = (_, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`admin/add/user/in/shop`, data)
            .then((response) => {
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export const removeUserFromShop = (_, data) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`admin/remove/user/in/shop`, { data })
            .then((response) => {
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}  

export const updateUserRoleInShop = (_, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`admin/update/user/role/in/shop`, data)
            .then((response) => {
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export const addStoresToShop = (_, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/add/stores/${data.shop_id}/shop`, data)
            .then((response) => {
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}
export const fetchStoresNotInShop = async ({ commit }, shopId) => {
    commit(types.SET_LOADING, true)

    try {
        const response = await window.axios.get(
            `get/stores/${shopId}/not_in/shop`
        )

        commit(
            types.SET_AVAILABLE_STORES,
            response.data.stores ?? []
        )

        return response
    } finally {
        commit(types.SET_LOADING, false)
    }
}

export const removeStoreFromShop = (_, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`remove/store/${data.shop_id}/shop`, data)
            .then((response) => {
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export const applyDgiTaxAllShopProducts = (_, shopId) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`admin/apply/dgi-tax/all/shop-products`, { shop_id: shopId })
            .then((response) => {
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export const applyDgiTaxAllSocietyProducts = (_, societyId) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`admin/apply/dgi-tax/all/society-products`, { society_id: societyId })
            .then((response) => {
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export const toggleShopNormalization = (_, { shopId, isEnabled, dgiTaxId = null }) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`admin/update/${shopId}/normalization-status`, {
            is_normalization_enabled: isEnabled,
            dgi_tax_id: dgiTaxId,
        })
            .then((response) => {
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}
